import * as React from 'react'
import tw from 'tailwind-styled-components'
import {LinkButton} from '@components/common/base/buttons'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {cn} from '@containers/html-utils'

const TwButtonContainer = tw.div`
  flex
  items-center
`

export interface Props {
  onMouseDown?: () => void
  onClick?: () => void
  icon: TablerIcons
  text: string
  className?: string
  iconPadding?: '4' | '8' | '12'
  height?: 'h-24' | 'h-32'
}

export const LinkButtonWrapped = (props: Props) => {
  const {onMouseDown, onClick, icon, className, text, iconPadding = '4'} = props
  const {height = 'h-24'} = props

  return (
    <TwButtonContainer className={cn(className, height)}>
      <LinkButton
        icon={icon}
        onMouseDown={onMouseDown}
        onClick={onClick}
        noPaddings
        iconPadding={iconPadding}
        size="small"
      >
        {text}
      </LinkButton>
    </TwButtonContainer>
  )
}
